module.exports = __webpack_public_path__ + "1.5.0-unryo/img/microsoft-windows.ea4e1d80.svg";